import { useState, useEffect } from "react";

import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

type ZeffyConfettiProps = {
  canLoadData: boolean;
};

export const ZeffyConfetti = ({ canLoadData }: ZeffyConfettiProps) => {
  const [confettiData, setConfettiData] = useState<{ left: object; right: object } | null>(null);

  useEffect(() => {
    const loadAnimations = async () => {
      const [leftData, rightData] = await Promise.all([
        import("./animations/zeffy_confetti_left.json"),
        import("./animations/zeffy_confetti_right.json"),
      ]);
      setConfettiData({
        left: leftData.default,
        right: rightData.default,
      });
    };

    if (canLoadData) {
      loadAnimations();
    }
  }, [canLoadData]);

  if (!confettiData) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          pointerEvents: "none",
        }}
      >
        <Lottie
          options={{
            animationData: confettiData.left,
            autoplay: true,
            loop: false,
          }}
          isClickToPauseDisabled={true}
        />
      </div>
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          pointerEvents: "none",
        }}
      >
        <Lottie
          options={{
            animationData: confettiData.right,
            autoplay: true,
            loop: false,
          }}
          isClickToPauseDisabled={true}
        />
      </div>
    </>
  );
};
